import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/lang/en/translations.yml'
import GET_STYLES from '@/graphql/GET_STYLES.gql'
import constants from '@/helpers/constants.js'

export const DEFAULT_LANG = 'en'

Vue.use(VueI18n)

// here we fetch the dynamic styles and custom brands and incorporate them
// into the i18n library under a locale called 'brand'
export async function getCustomBrandStyles (hostname, apollo) {
  try {
    const { data } = await apollo.query({
      query: GET_STYLES,
      variables: {
        hostname: hostname
      }
    })
    return data
  } catch (e) {
    return {getBrandByDomainName:null}
  }
}

export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  fallbackLocale: DEFAULT_LANG,
  silentFallbackWarn: true,
  messages
})
